import * as React from 'react';
import * as ReactDOM from 'react-dom';

import GalleryRoot from './components/rootComponents/GalleryRoot';

declare var Raven: any;
declare var window: any;

Raven.context(() => {
    ReactDOM.render(
        <GalleryRoot
            categories={ window.props.categories }
            prezis={ window.props.prezis }
            categoryString={ window.props.categoryString }
            headerColor={ window.props.headerColor }
            activeGalleryTab={ window.props.activeGalleryTab }
            presentationsTabString={ window.props.presentationsTabString }
            videosTabString={ window.props.videosTabString }
            designTabString={ window.props.designTabString }
            isUseAsTemplateFlowActive={ window.props.isUseAsTemplateFlowActive }
            templateFlowPageTitleString={ window.props.templateFlowPageTitleString }
        />,
        document.getElementById('app'),
    );
});



// WEBPACK FOOTER //
// ./assets/js/GalleryIndex.tsx